var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"link-arrow",attrs:{"to":_vm.link}},[_c('span',{staticClass:"link-arrow__content"},[_vm._t("default")],2),_vm._v(" "),_c('i',{staticClass:"icon-arrow-right link-arrow__icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }